export enum Edition {
  Asia = "asia",
  HongKong = "hk",
  International = "int",
}

export const editions = {
  [Edition.International]: { href: "/", label: "International" },
  [Edition.HongKong]: { href: "/hk", label: "Hong Kong" },
  [Edition.Asia]: { href: "/asia", label: "Asia" },
} as const;

export const editionOptions = [Edition.International, Edition.HongKong, Edition.Asia].map(
  edition => ({ value: edition, ...editions[edition] }),
);

export const headerEditionOptions = [Edition.HongKong, Edition.International, Edition.Asia].map(
  edition => ({ value: edition, ...editions[edition] }),
);
